<template>
  <v-app app v-if="authStore.userData || $route.path === '/login'">
    <!-- Support Impersonation Banner -->
    <impersonation-banner />

    <!-- Global Alert Banner - Self-contained component -->
    <global-alert-banner />

    <v-img
      @click="$router.push('/')"
      class="logo-image cursor-pointer"
      src="@/assets/syft_logo.svg"
      height="37"
      width="37"
      contain
    />

    <navigation-card
      v-if="authStore.userData"
      @toggle-workspace-nav="showWorkspaceNav = !showWorkspaceNav"
    />

    <v-navigation-drawer
      :order="-1"
      v-model="showWorkspaceNav"
      disable-resize-watcher
      :temporary="showWorkspaceNav"
    >
      <workspace-navigation v-if="showWorkspaceNav" />
    </v-navigation-drawer>
    <v-main app class="pl-10">
      <router-view :key="$route.fullPath" v-if="authStore.userData || $route.path === '/login'" />
    </v-main>
    <v-snackbar
      v-model="communicationStore.snack.show"
      :vertical="communicationStore.snack.vertical"
      :color="communicationStore.snack.color"
      location="top"
      data-test="snack-bar"
    >
      <v-icon start> mdi-check </v-icon>
      {{ communicationStore.snack.message }}
      <template #actions>
        <v-btn
          size="small"
          variant="text"
          @click="
            communicationStore.setSnack({
              show: false
            })
          "
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="communicationStore.routeSnack.show"
      location="top"
      :timeout="communicationStore.routeSnack.timeout"
      :color="communicationStore.routeSnack.color"
      class="py-0"
    >
      <v-row align="center" dense class="py-0">
        <v-col cols="auto">
          <v-icon
            @click="
              communicationStore.setRouteSnack({
                show: false
              })
            "
            >mdi-close-circle</v-icon
          >
        </v-col>
        <v-col>
          {{ communicationStore.routeSnack.message }}
        </v-col>
      </v-row>
      <template #actions>
        <v-btn size="small" text @click="handleRouteToLocation">
          {{ $t('snackBar.visit') }}
          <v-icon end> mdi-arrow-right </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapStores } from 'pinia'
import { useCommunicationStore } from './store/communication'
import { useFilterStore } from '@/store/filter'
import { useAuthStore } from '@/store/auth'
import { useTheme } from 'vuetify'
import NavigationCard from '@/components/nav/NavigationCard.vue'
import WorkspaceNavigation from './components/workspaces/WorkspaceNavigation.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'
import GlobalAlertBanner from '@/components/user-communication/GlobalAlertBanner.vue'
import { THEME_STORAGE_KEY } from '@/config/constants'

export default {
  components: {
    NavigationCard,
    WorkspaceNavigation,
    ImpersonationBanner,
    GlobalAlertBanner
  },
  setup() {
    const theme = useTheme()
    return { theme }
  },
  data() {
    return {
      showWorkspaceNav: false
    }
  },
  computed: {
    ...mapStores(useAuthStore, useCommunicationStore, useFilterStore)
  },

  watch: {
    'authStore.userIsDisabled': {
      immediate: true,
      handler(userIsDisabled) {
        if (userIsDisabled && this.$route.path !== '/account-paused') {
          this.$router.push('/account-paused')
        }
      }
    }
  },

  methods: {
    handleRouteToLocation() {
      this.$router.push(this.communicationStore.routeSnack.route)
      this.communicationStore.setRouteSnack({
        show: false
      })
    }
  },

  async mounted() {
    // Initialize theme from localStorage
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY)
    if (savedTheme && ['light', 'dark', 'system'].includes(savedTheme)) {
      this.theme.change(savedTheme)
    }
  }
}
</script>

<style lang="scss" scoped>
.helpButton {
  position: fixed;
  bottom: 0.5rem;
  right: 0.5rem;
  z-index: 1000;
}

.logo-image {
  position: fixed;
  top: 1.65rem;
  left: 1.65rem;
}
</style>
